<template>
  <div v-if="modalPush">
    <modal-bottom :opened="modal" style="z-index: 99999">
      <div class="container mt-4">
        <h5 class="mb-3">Quer receber um alerta quando seu pedido for confirmado ou estiver saindo para entrega?</h5>
        <p class="mb-4">
          Não será possível informar as alterações de status do seu pedido. Clique em "Ativar Alerta" para receber as atualizações.
        </p>
        <div class="alert alert-warning text-center mb-2" v-if="alert">{{alert}}</div>
        <div>
          <button class="btn btn-primary btn-block rounded-sm p-2 mb-3" @click="webPushSubscription" :disabled="btnLoad" v-if="btnShow">
            <span v-show="!btnLoad"><b>Ativar Alerta</b></span>
            <span v-show="btnLoad"><i class="fa fa-spinner fa-spin"></i> <b class="pl-2">Aguardando confirmação..</b></span>
          </button>
          <button type="button" class="btn btn-block rounded-sm p-3 mb-2" @click="fecharModal()">
            <span class="font-weight-bold text-primary">Não, Obrigado</span>
          </button>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import Loading from "./Loading";
  import ModalBottom from "./ModalBottom";

  export default {
    name: 'Onesignal',
    components: {ModalBottom, Loading },
    props: ['isComponent', 'emAndamento'],
    data() {
      return {
        btnLoad: false,
        btnShow: false,
        alert: '',
        modal: false,
        wasInit: false
      }
    },

    methods: {
      voltar() {
        if (this.menu) {
          this.menu = 0;

        } else {
          this.$router.go(-1)
        }
      },

      webPushSubscription() {
        if (Notification.permission === 'denied') {
          this.btnShow = false;
          this.alert = "Suas notificações estão bloqueadas. Por favor limpe suas permissões no navegador para habilitar essa funcionalidade.";
          return;
        }

        this.btnLoad = true;

        this.$OneSignal.isPushNotificationsEnabled().then(isPushEnabled => {
          if (!isPushEnabled) {

            this.$OneSignal.getSubscription().then(isOptedOut => {
              if (!isOptedOut) {
                this.$OneSignal.setSubscription(true).then(() => {
                  if (this.$route.name === 'Notificacao') {
                    window.location.href = this.$route.path;

                  } else {
                    this.modal = false;
                  }
                });

              } else {
                this.$OneSignal.registerForPushNotifications();
              }
            });

          } else {
            this.btnLoad = false;
            this.alert = "A notificação já está habilitada";
          }
        });
      },

      fecharModal() {
        this.modal = false;
      },

      iniciar() {
        if (this.oneSignalIntegration) {
          this.modal = this.$route.name === 'Notificacao';
          const OneSignal = window.OneSignal || [];

          if (!OneSignal || !OneSignal.isPushNotificationsSupported()) {
            this.alert = "Notificações não suportada neste dispositivo."
            return;
          }

          if (Notification.permission === 'denied') {
            this.alert = "As notificações estão bloqueadas neste dispositivo."
            return;
          }

          this.$OneSignal.isPushNotificationsEnabled().then(isPushEnabled => {
            if (isPushEnabled) {
              this.alert = "A notificação já está habilitada";

            } else {
              this.modal = true;
              this.btnShow = true;
            }
          });

          if (!this.wasInit) {
            console.log('iniciando onesignal');
            this.wasInit = true;

            this.$OneSignal.on("subscriptionChange", (isActive) => {
              this.btnLoad = true;

              if (!isActive) {
                this.modal = false;
                return;
              }

              const token = localStorage.getItem('token');

              if (this.usuario.id_cliente && token) {
                this.$OneSignal.setExternalUserId(this.usuario.id_cliente).then(res => {
                  this.$http.post(this.empresa.token + '/' + token + '/cliente/onesignal', { push_habilitado: '1' }).then(res => {
                    this.modal = false;

                    if (this.$route.name === 'Notificacao') {
                      window.location.href = this.$route.path;
                    }

                  }, () => {
                    this.alert = "Erro ao vincular as notificações";
                  });
                });

              } else {
                this.modal = false;
              }
            });

            this.$OneSignal.on("permissionPromptDisplay", () => {
              this.alert = "Clique em permitir para concluir!";
            });

            this.$OneSignal.on("notificationPermissionChange", (res) => {
              if (res && res.to === 'denied') {
                this.modal = false;
              }
            });
          }

        } else {
          this.alert = "Esta funcionalidade ainda não está disponível.";
        }
      }
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      empresa() {
        return this.$store.state.empresa;
      },

      modalPush() {
        return this.$store.state.modalPush
      }
    },

    watch: {
      modalPush() {
        this.iniciar();
      }
    }
  }
</script>

<style scoped>

</style>
